import { faGripLines, faArrowDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Draggable } from "react-beautiful-dnd";
import IconOrSpinner from "../../../../../../../Components/Utils/IconOrSpinner";
import { DeletarConfigEnvelopeDestinatarioController } from "../../../../../../../Controllers/Geral/ConfigEnvelope/ConfigEnvelopeDestinatario/ConfigEnvelopeDestinatarioControllers";
import useAsyncCallback from "../../../../../../../hooks/useAsyncCallback";
import { IConfigEnvelopeDestinatario } from "../../../../../../../Interfaces/Geral/ConfigEnvelope/ConfigEnvelopeDestinatario/ConfigEnvelopeDestinatarioInterfaces";

interface IDestinatarioConfigEnvelopeSelecionadoProps {
    destinatario: IConfigEnvelopeDestinatario;
    updateList: () => void;
}

export default function DestinatarioConfigEnvelopeSelecionado(
    props: IDestinatarioConfigEnvelopeSelecionadoProps
) {
    const { destinatario } = props;

    const {
        execute: deletarConfigEnvelopeDestinatario,
        loading: desvinculando,
    } = useAsyncCallback(async (id: number) => {
        await DeletarConfigEnvelopeDestinatarioController(id).then(
            props.updateList
        );
    }, []);

    return (
        <div
            className="m-2"
            key={destinatario.ID_ENVELOPE_DOCUSIGN_CONFIG_DESTINATARIO}
        >
            <Draggable
                draggableId={destinatario.ID_ENVELOPE_DOCUSIGN_CONFIG_DESTINATARIO.toString()}
                index={destinatario.NR_ORDEM}
            >
                {(providedDrag) => (
                    <div
                        className="d-flex justify-content-between p-2"
                        ref={providedDrag.innerRef}
                        {...providedDrag.draggableProps}
                        {...providedDrag.dragHandleProps}
                    >
                        <div className="d-flex align-items-center g-2">
                            <FontAwesomeIcon icon={faGripLines} />
                            <h4 className="m-0">
                                {destinatario.DS_DESTINATARIO}
                            </h4>
                        </div>
                        <button
                            className="btn btn-outline-danger"
                            onClick={() => {
                                deletarConfigEnvelopeDestinatario(
                                    destinatario.ID_ENVELOPE_DOCUSIGN_CONFIG_DESTINATARIO
                                );
                            }}
                            disabled={desvinculando}
                        >
                            <IconOrSpinner
                                icon={faArrowDown}
                                loading={desvinculando}
                                loadingSize="sm"
                            />
                        </button>
                    </div>
                )}
            </Draggable>
        </div>
    );
}
